const scrollToTabs = () => {
  const targetSlug = '/swimming-pool-photos/'; // Your slug for the target page
  const targetElementSelector = '.e-stn--photo-gallary .e-tbs--slider-tabs'; // Target element to scroll to

  // Smooth scroll to the target element
  const target = document.querySelector( targetElementSelector );
  if ( window.location.pathname === targetSlug && target ) {
    const header = document.querySelector( 'header' ); // Assuming your header element is <header>
    const offsetTop = target.getBoundingClientRect().top + window.pageYOffset;
    const headerHeight = header ? header.offsetHeight : 0; // Get header height, fallback to 0
    const reducedHeaderHeight = headerHeight * 1.1; // Reduce header height by 20%
    const adjustedPosition = offsetTop - reducedHeaderHeight;

    // Smooth scroll to the adjusted position
    window.scrollTo( {
      top: adjustedPosition,
      behavior: 'smooth'
    } );
  } 
};

const scrollOnLoad =() => {
  const targetSlug = '/swimming-pool-photos/'; // Your slug for the target page
  const targetElementSelector = '.e-stn--photo-gallary .e-tbs--slider-tabs'; // Target element to scroll to
  const hash = window.location.hash;
  const target = document.querySelector( targetElementSelector );
  if ( window.location.pathname === targetSlug && target && hash!='' ) {
    document.querySelector( `header .mega-pool-tabs a[href*="${hash}"]` ).click();
  }
};

export { scrollOnLoad, scrollToTabs };
